const CircleArrowLeft02Icon = /*#__PURE__*/ [
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9.00009 12.0002L16.0001 12.0002M11.4999 8.50012C11.4999 8.50012 7.99995 11.0778 7.99995 12.0001C7.99994 12.9225 11.4999 15.5001 11.4999 15.5001", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { CircleArrowLeft02Icon as default };
//# sourceMappingURL=CircleArrowLeft02Icon.js.map
